import * as go from 'gojs';
import { getImageMobileHSI } from 'unitData/Mobile/HSI/getImageMobileHSI';
import { alignPorts } from 'unitData/Mobile/HSI/hsiData';
import {
  getImageBinding,
  getMobileInputPort,
  getMobileOutputPort,
  makeNode,
  mobileUnitDefaultOptions,
} from '../../utils';
import type { MobileUnitBaseNodeData } from 'gojs/types';

const MobileHSITemplate = makeNode(
  getImageBinding('', (node: MobileUnitBaseNodeData) =>
    getImageMobileHSI(node.model, node.configuration.configKey),
  ),
  [
    getMobileOutputPort(0, alignPorts),
    getMobileOutputPort(1, alignPorts),
    getMobileOutputPort(2, alignPorts),
    getMobileOutputPort(3, alignPorts),
    getMobileInputPort((node) => {
      return node.mirrored
        ? new go.Spot(1 - 3 / 12, 0)
        : new go.Spot(3 / 12, 0);
    }),
  ],
  { ...mobileUnitDefaultOptions },
);

export default MobileHSITemplate;
